import { SearchBusinessesBusinessPreview as SearchBusinessesBusinessPreviewComponent } from './SearchBusinessesBusinessPreview';

export const SearchBusinessesBusinessPreview =
	SearchBusinessesBusinessPreviewComponent;
